// This file is auto-generated by dibs-icons script
import { type FC } from 'react';

type FastTimer14Props = {
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const FastTimer14: FC<FastTimer14Props> = props => {
    return (
        <svg
            style={{ display: 'block' }}
            data-tn={props.dataTn}
            role={props.role}
            aria-label={props.ariaLabel}
            aria-labelledby={props.ariaLabelledby}
            width="14"
            height="14"
        >
            <path d="M8.924 11.2c-1.166 0-2.157-.408-2.974-1.225-.817-.817-1.225-1.808-1.225-2.974 0-1.158.408-2.147 1.225-2.969C6.767 3.211 7.758 2.8 8.924 2.8c1.158 0 2.147.41 2.969 1.232.821.822 1.232 1.811 1.232 2.969 0 1.166-.41 2.157-1.232 2.974-.822.817-1.811 1.225-2.969 1.225Zm-.006-1.05c.88 0 1.626-.304 2.238-.911.613-.608.919-1.352.919-2.232 0-.88-.306-1.626-.919-2.238a3.038 3.038 0 0 0-2.231-.919c-.885 0-1.63.306-2.239.919C6.08 5.38 5.775 6.125 5.775 7c0 .885.304 1.63.911 2.239.608.607 1.352.911 2.232.911Zm1.203-1.196.744-.744-1.416-1.418V4.9H8.4v2.322l1.72 1.732ZM1.75 5.25V4.2h2.1v1.05h-2.1Zm-.7 2.275v-1.05h2.8v1.05h-2.8Zm.7 2.275V8.75h2.1V9.8h-2.1Z" />
        </svg>
    );
};

export default FastTimer14;
